<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card min-height">
      <div class="card-body">
        <div class="px-4 pb-4">
          <h2 class="card-title-desc">Processed Payments</h2>
          <TableLoading v-if="orders.page === 0"/>
          <div v-else>
            <data-table :columns="columns" :rows="orders.objects" :current-page="currentPage" :has-pagination="false" @onSearch="searchFn">
              <template v-slot:actions="slotProps" v-if="checkForPermission(mark_order_as_deposited_permission)">
                <b-button v-if="slotProps.row.depositDetails === null" variant="primary" size="sm" class="py-1 text-white" @click="markAsDeposited(slotProps.row.publicId)">
                  Mark as Deposited
                </b-button>
                <!-- <b-button
                  v-if="withinPastSevenDays(slotProps.row.paymentDetails.createdAt)"
                  v-b-modal.cancel-payment
                  variant="danger"
                  size="sm"
                  class="py-1 text-white"
                  @click="selectPaymentToCancel(
                    slotProps.row.invoiceId,
                    slotProps.row.publicId,
                    slotProps.row.customer.name,
                    slotProps.row.deliveryDate,
                    slotProps.row.paymentDueDate,
                  )">
                  Cancel Payment
                </b-button> -->
                <!--              <payment-status-component v-else :payment_status="slotProps.row.paymentStatus.name"/>-->
              </template>
              <div class="row mb-4">
                <div class="col-sm-5 col-12 mt-2" v-if="isUserStaff()">
                  <button v-if="httpLoading" class="btn btn-dark me-1" :disabled="httpLoading">Loading</button>
                  <div v-else class="d-md-flex d-sm-inline">
                    <date-picker v-model="selectedReportDates" range class="me-3 mb-1" placeholder="Select Dates for Report"></date-picker>
                    <button class="btn btn-info me-1 w-100 mb-1" @click="downloadPaymentsReport">Download Payments Report</button>
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-sm-3 col-12">
                  <div class="input-group mb-3">
                    <label class="input-group-text bg-primary text-white">Deposited</label>
                    <select class="form-select" @change="depositedStatusFilter($event)">
                      <option value="all" selected>All</option>
                      <option :value="1">Yes</option>
                      <option :value="2">No</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-3 col-12">
                  <div class="input-group mb-3">
                    <label class="input-group-text bg-primary text-white">Payment Methods</label>
                    <select class="form-select" @change="paymentStatusFilter($event)">
                      <option value="all" selected>All</option>
                      <option value="9f9d8765-610f-4112-aa7a-5e92e22cbecb">Mpesa</option>
                      <option value="e3d9310c-ed9b-450b-8b02-fb32daa03e14">Cheque</option>
                      <option value="0f4f6de8-bc58-4a41-9597-72447dbe1de9">Cash</option>
                      <option value="b03943ee-ee06-4518-b69c-3c091b68a226">Bank Transfer</option>
                      <option value="6642a601-83ab-4e45-bb20-5f20c1ffc29f">Airtel Money</option>
                    </select>
                  </div>
                </div>
              </div>
            </data-table>
            <b-pagination
                v-model="currentPage"
                :total-rows="orders.total"
                :per-page="perPage"
                size="lg"
                align="center"
                class="mt-3"
            />
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="cancel-payment"
      centered
      hide-footer
      hide-header
      title-class="font-18">
      <h3>Cancel Payment for #{{ orderToCancel.invoiceId }}</h3>
      <div class="row mt-4 h5">
        <div class="col-5 mb-4"><b>Customer:</b></div>
          <div class="col-6 mb-4">{{ orderToCancel.customer }}</div>
          <div class="col-5 mb-4"><b>Invoice #:</b></div>
          <div class="col-6 mb-4">{{ orderToCancel.invoiceId }}</div>
          <div class="col-5 mb-4"><b>Delivery Date:</b></div>
          <div class="col-6 mb-4"><date-is-today :current_date="orderToCancel.deliveryDate"/></div>
          <div class="col-5 mb-4"><b>Payment Due Date:</b></div>
          <div class="col-6 mb-4"><date-is-today :current_date="orderToCancel.paymentDueDate"/></div>
      </div>
      <div></div>
      <b-button class="mt-3 float-end" variant="dark" block @click="$bvModal.hide('cancel-payment')">Close</b-button>
    </b-modal>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import DataTable from "@/components/data-table";
import {ALL_CUSTOMER_ORDERS_FINANCE} from "@/gql/orders";
import {mapActions, mapGetters} from "vuex";
import {successToast} from "@/components/successToast";
import TableLoading from "@/components/TableLoading";
import {permissions} from "@/router/permissions";
import moment from 'moment'
import DateIsToday from "@/components/orders/date-is-today";
import {downloadFileConfig} from "@/filters/downloadFileConfig";
import {errorToast} from "@/components/successToast";

export default {
  page: {
    title: "Processed Payments",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    TableLoading,
    DataTable,PageHeader, Layout,
    DateIsToday},
  name: "processed-payments",
  data() {
    return {
      title: "Processed Payments",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Processed Payments",
          active: true
        }
      ],
      mark_order_as_deposited_permission: permissions.mark_order_as_deposited_permission,
      filterValue: '',
      orderToCancel: {
        invoiceId: '',
        publicId: '',
        customer: '',
        deliveryDate: '',
        paymentDueDate: '',
        payments: [],
        cancelled: false,
      },
      selectedReportDates: '',
      orders: {
        page: 0,
        objects: []
      },
      currentPage: 1,
      perPage: 30,
      searchKeyword: "",
      paymentStatus: [10],
      isDeposited: 0,
      paymentMethods: [],
      columns: [
        {
          field: 'customer.customerCode',
          label: 'Customer Code'
        },
        {
          field: 'customer.name',
          label: 'Customer Name'
        },
        {
          field: 'invoiceId',
          label: 'Order'
        },
        {
          field: 'paymentReceivedDate',
          label: 'Payment Received',
        },
        {
          field: 'paymentDetails.createdAt',
          label: 'Payment Recorded',
        },
        {
          field: 'paymentDetails',
          label: 'Payment Method',
        },
        {
          field: 'paymentDetails.paymentRef',
          label: 'Transaction Reference',
        },
        {
          field: 'paymentStatus',
          label: 'Payment Status'
        },
        {
          field: 'paymentDetails.amountPaid',
          label: 'Amount Paid'
        },
        {
          field: 'grossOrderTotal',
          label: 'Total Due'
        },
        {
          field: 'actions',
          label: 'Action'
        },
      ]
    }
  },
  apollo: {
    orders: {
      query: ALL_CUSTOMER_ORDERS_FINANCE,
      variables(){
        return {
          page: this.currentPage,
          perPage: this.perPage,
          searchKeyword: this.searchKeyword,
          orderPayment: this.paymentStatus,
          paymentMethods: this.paymentMethods,
          isDeposited: this.isDeposited
        }
      }
    }
  },
  computed: {
    statusFilter(){
      let records = this.rows
      if (this.filterValue){
        records =  this.rows.filter(record => record.payment_status.toLowerCase() === this.filterValue)
      }
      return records
    },
    ... mapGetters({
      httpLoading: 'http/httpLoading',
      httpErrors: 'http/httpErrors',
    })
  },
  watch: {
    currentPage(){
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  },
  mounted() {
    this.currentPage = parseInt(this.$route.query.page) || 1
  },
  methods: {
    ... mapActions({
      changePaymentDeposit: 'orders/changeOrderPaymentDeposit',
      generatePaymentsReport: 'http/generatePaymentsReport'
    }),
    async markAsDeposited(data){
      await this.changePaymentDeposit({'orderId': data}).then(resp => {
        if(resp.message){
          successToast(`${resp.message}`)
          this.$apollo.queries.orders.refetch()
        }
      })
    },
    searchFn(data){
      this.searchKeyword = data
    },
    changeStatusFilter(event){
      this.filterValue = event.target.value
    },
    depositedStatusFilter(event){
      const value = event.target.value
      if(event.target.value === 'all'){
        this.isDeposited = 0
      }else {
        this.isDeposited = parseInt(value)
      }
    },
    paymentStatusFilter(event){
      const value = event.target.value
      if(event.target.value === 'all'){
        this.paymentMethods = []
      }else {
        this.paymentMethods = [value]
      }
    },
    withinPastSevenDays(paymentRecordedDate) {
      const today = moment()
      const paymentRecorded = moment(paymentRecordedDate)
      const duration = moment.duration(today.diff(paymentRecorded))
      const diff = duration.asDays()
      if (diff > 7) {
        return false
      } else {
        return true
      }
    },
    selectPaymentToCancel(invoiceId, publicId, customer, deliveryDate, paymentDueDate) {
      this.orderToCancel.invoiceId = invoiceId
      this.orderToCancel.publicId = publicId
      this.orderToCancel.customer = customer
      this.orderToCancel.deliveryDate = deliveryDate
      this.orderToCancel.paymentDueDate = paymentDueDate
    },
    async downloadPaymentsReport(){
      if (this.selectedReportDates !== ''){
        const start = moment(this.selectedReportDates[0]).format('YYYY-MM-DD')
        const end = moment(this.selectedReportDates[1]).format('YYYY-MM-DD')
        const response = await this.generatePaymentsReport({'start': start, 'end': end})
        if(response.data.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
          downloadFileConfig(response, `Payments Report ${start} - ${end}.xlsx`)
        }else {
          errorToast('Error generating payments report')
        }
      }else {
        errorToast('Date selection cannot be blank')
      }
    }
  }
}
</script>

<style scoped>

</style>
